import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FAQS } from "../data/content";

export const FaqList = ({ limit }) => (
  <Accordion type="single" collapsible className="border-t border-slate-200" data-testid="faq-list">
    {FAQS.slice(0, limit || FAQS.length).map((f, i) => (
      <AccordionItem key={f.q} value={`faq-${i}`} className="border-slate-200">
        <AccordionTrigger className="py-5 text-left font-display text-lg sm:text-xl uppercase tracking-wide font-semibold text-slate-900 hover:no-underline hover:text-brand-600 [&>svg]:text-orange-600" data-testid={`faq-trigger-${i}`}>
          <span className="flex gap-4"><span className="font-mono text-xs text-orange-600 mt-1.5">{String(i + 1).padStart(2, "0")}</span>{f.q}</span>
        </AccordionTrigger>
        <AccordionContent className="pl-9 pr-4 text-slate-600 text-base leading-relaxed" data-testid={`faq-content-${i}`}>{f.a}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
